import { Task, Timestamp, WeekDays } from '@griply/types';
import { endOfDay, isSameDay, startOfDay } from 'date-fns';

import { getFrequencyTimeframeCompletions } from './get-frequency-timeframe-completions';
import { getTimeframeSchedules } from './schedules';

export type GetTaskDayCompletionPercentageOptions = {
  day: Timestamp;
  weekStartsOn: WeekDays;
};

export const getTaskDayCompletionPercentage = (
  task: Task,
  { day, weekStartsOn }: GetTaskDayCompletionPercentageOptions,
) => {
  if (!task.schedules?.length) {
    return task.completedAt ? 100 : undefined;
  }

  const schedule = getTimeframeSchedules(task.schedules ?? [], {
    startDate: startOfDay(day),
    endDate: endOfDay(day),
  }).pop();

  if (!schedule) {
    return 0;
  }

  if (!schedule.frequency) {
    if (schedule.completionTarget.count === 1) {
      return undefined;
    }

    const entry = schedule.entries.find(({ date }) => isSameDay(date, day));

    if (!entry?.value) {
      return 0;
    }

    return (entry.value / schedule.completionTarget.count) * 100;
  }

  const { completionsCount, target } = getFrequencyTimeframeCompletions(
    schedule,
    { referenceDate: day, weekStartsOn },
  );

  return (completionsCount / target) * 100;
};
